import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'

export const subscriptions = {
    getServiceRecommendation,
    updateService
}

async function getServiceRecommendation({
    page = 1,
    size = 10,
    contact_id,
    account_id,
    include_components,
    include_creatives,
    organisation_id,
    sort,//='UPDATED_DATE',
    order, //='DESC'
    include_total, 
    service_id,
    subscription_id,
} = {},) {
    try {

        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v2/services/recommendation',
            queryParams: {
                page,
                size,
                contact_id,
                account_id,
                include_components,
                include_creatives,
                include_total,
                order,
                organisation_id,
                sort,
                service_id,
                subscription_id,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getServiceRecommendation: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateService({
    id,
    action,                // ACTIVATE | CANCEL | ...
    category_id,
    scheduled_date,        // timestamp (unix)
    use_proposed_date,     // boolean
    number_of_days,        // int (nếu pause)
    quantity,              // int (nếu change)
    price_terms_id,
    change_to_service,
    components,
    pass,
    locations,
    enabled_devices,
  } = {}) {
    try {
      const response = await httpUtil.put({
        resourcePath: `/v2/services/${id}`,
        body: {
          action,
          category_id,
          scheduled_date,
          use_proposed_date,
          number_of_days,
          quantity,
          price_terms_id,
          change_to_service,
          components,
          pass,
          locations,
          enabled_devices,
        },
      });
  
      return createCommonResult(response);
    } catch (e) {
      console.log("Exception updateService: ", e);
      return createResult(ErrorCodes.UNKNOWN, e);
    }
  }
